import { LABEL_CLASS } from '@/components/common/node-view-settings-panel';
import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import type { ReactNodeViewProps } from '@tiptap/react';
import { NodeViewContent } from '@tiptap/react';

function ZyITLabRichInstructionsNodeView({ label, decorations }: ReactNodeViewProps & { label: string }) {
    return (
        <ZyNodeViewWrapper decorations={decorations}>
            <div
                contentEditable={false}
                className={LABEL_CLASS}
            >
                {label}
            </div>
            <div className="mb-3 rounded border border-gray-200 bg-white p-3 dark:border-gray-700 dark:bg-gray-950">
                <NodeViewContent />
            </div>
        </ZyNodeViewWrapper>
    );
}

export function ZyITLabTaskInstructionsNodeView(props: ReactNodeViewProps) {
    return (
        <ZyITLabRichInstructionsNodeView
            {...props}
            label="Task instructions"
        />
    );
}

export function ZyITLabStepInstructionsNodeView(props: ReactNodeViewProps) {
    return (
        <ZyITLabRichInstructionsNodeView
            {...props}
            label="Instructions"
        />
    );
}
